module.exports = __webpack_public_path__ + "img/HV_cv.22bd2813.jpeg";